<template>
  <div class="layAnnotationList">
    <div class="content-bg">
      <div class="line-bg">
        <div class="line-box" v-for="(item, index) in dataList" :key="item">
          <div class="line"></div>
          <el-input
            class="line-left"
            v-model="item.keyWord"
            placeholder="enter keyword"
            @mouseout="mouseOutInput"
            @focusin="keyUpEnter"
            :readonly="!isCanEdite"
          ></el-input>
          <el-input
            class="line-right"
            v-model="item.keyValue"
            placeholder="enter describle"
            @mouseout="mouseOutInput"
            @focusin="keyUpEnter"
            :readonly="!isCanEdite"
          ></el-input>
          <img
            :src="item.img"
            @mouseover="mouseOver(item)"
            @mouseout="mouseOut(item)"
            @click="deleteDo(item, index)"
            v-show="isCanEdite"
          />
        </div>
        <div class="add-box" v-show="isCanEdite">
          <div class="line"></div>
          <div class="add-item">
            <div class="add-font" @click="addItem">+</div>
          </div>
        </div>
      </div>
    </div>
    <UniversalPopover :dialogVisible="showVisible" :title="title" :brightTitle="brightTitle" @cancelDo="cancelDo"
        @comfirmDo="comfirmDo"></UniversalPopover>
  </div>
</template>
<script>
import UniversalPopover from "@/components/UniversalPopover.vue";
export default {
  name: "layAnnotationList",
  props: {
    annotationList: {
      type: Array,
      default: () => [],
    },
    isCanEdite: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    annotationList(val) {
      this.dataList = val;
    },
  },
  data() {
    return {
      longColor: "#ffffff",
      longBgColor: "#0052D9",
      shortColor: "#A6A6A6",
      shortBgColor: "#F5F5F5",
      dataList: this.annotationList,
      isInputing: false,
      showVisible: false,
      title: "",
      brightTitle: "",
      deleteItem: {},
      deleteIndex: 0,
    };
  },
  methods: {
    cancelDo() {
      this.showVisible = false;
    },
    comfirmDo() {
      if (this.deleteItem.isSelected) {
        this.cancelDo()
        this.dataList.splice(this.deleteIndex, 1);
        this.$emit("deleteDo");
      }
    },
    mouseOutInput() {
      if (this.isInputing) {
        this.$emit("mouseOutInput");
      }
      this.isInputing = false;
    },
    keyUpEnter() {
      console.log("keyUpEnter");
      this.isInputing = true;
    },
    longDo() {
      console.log("longDo");
      this.longColor = "#fff";
      this.longBgColor = "#0052D9";
      this.shortColor = "#A6A6A6";
      this.shortBgColor = "#F5F5F5";
    },
    shortDo() {
      console.log("shortDo");
      this.longColor = "#A6A6A6";
      this.longBgColor = "#F5F5F5";
      this.shortColor = "#fff";
      this.shortBgColor = "#0052D9";
    },
    mouseOver(item) {
      item.img = require("@/assets/data-select-icon.png");
      // item.isSelected = true;
    },
    mouseOut(item) {
      item.img = require("@/assets/data-normal-icon.png");
      // item.isSelected = false;
    },
    deleteDo(item, index) {
      item.isSelected = true
      this.deleteItem = item;
      this.deleteIndex = index;
      if (item.keyWord || item.keyValue) {
        this.title = 'are you sure to delete '
        this.brightTitle = item.keyWord
        this.showVisible = true;  
      } else {
        this.comfirmDo()
      }
      
    },
    addItem() {
      const item = {
        keyWord: "",
        keyValue: "",
        isSelected: false,
        img: require("@/assets/data-normal-icon.png"),
      };
      this.dataList.push(item);
      this.$emit("addItem")
    },
  },
  created() {},
  components: {
    UniversalPopover
  }
};
</script>
<style lang='less' scoped>
.layAnnotationList {
  background-color: #f5f5f5;
  width: 100%;
}

.content-bg {
  margin-top: 30px;
  width: 100%;
  margin: 0 auto;

  .line-bg {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  
  .line-box {
    display: flex;
    background-color: #fff;
    // padding-bottom: 10px;
    padding: 10px 0px 10px 0px;
    position: relative;
    align-items: center;
    // background-color: red;
    // height: 45px;

    // height: 60px;
    .line {
      
      width: 5px;
      height: 40px;
      background-color: #fbad15;
    }
    .line-left {
      color: #383838;
      margin-left: 30px;
      display: flex;
      width: 300px;
    }

    :deep(.line-left .el-input__wrapper) {
      border: 0;
      background-color: #ecf2fe;
      width: 300px !important;
      box-shadow: none !important;
    }

    .line-right {
      color: #383838;
      margin-left: 0px;
      width: calc(100% - 460px);
      margin-left: 45px;
    }

    :deep(.line-right .el-input__wrapper) {
      border: 0;
      background-color: #f5f5f5;
      box-shadow: none !important;
    }

    img {
      position: absolute;
      right: 30px;
      height: 35px;
      width: 35px;
      cursor: pointer;
    }
  }

  .add-box {
    background-color: #fff;
    padding: 10px 30px 10px 0px;
    display: flex;

    .line {
      width: 5px;
      height: 40px;
      background-color: #a6a6a6;
    }
    .add-item {
      height: 40px;
      display: flex;
      align-items: center;
      width: 300px;
      margin-left: 30px;
      background-color: #ecf2fe;
      padding-left: 5px;

      border-radius: 3px;

      .add-font {
        cursor: pointer;
        display: flex;
        height: 100%;
        padding: 10px;
        // background-color: red;
        font-size: 30px;
        font-weight: 400;
        align-items: center;
      }
    }
  }
  }
}
</style>